<app-email-list
    (newEmail)="newEmail()"
    [newEmailPermission]="'customers.maintain-customers.send-customer-email'"
    [references]="[{ id: customer?.ID_Customer, type: 'customer' }]"></app-email-list>
